import isBefore from 'date-fns/isBefore';
import parseISO from 'date-fns/parseISO';
import gradeTypes from './gradeTypes';

const isEmpty = (str) => !str || str === '';

export const validateHandinAssignment = ({
  title,
  startDate,
  endDate,
  isGroupAssignment,
  groupSet,
}) => ({
  title: isEmpty(title),
  startDate: isEmpty(startDate),
  endDate: isEmpty(endDate) || isBefore(parseISO(endDate), parseISO(startDate)),
  isGroupAssignment: isGroupAssignment && isEmpty(groupSet),
});

export const validateTurnItInAssignment = ({
  title,
  startDate,
  endDate,
  gradesReleasedAt,
  gradeType,
  maxGrade,
}) => ({
  title: isEmpty(title) || title.length < 2,
  startDate: isEmpty(startDate),
  endDate: isEmpty(endDate) || isBefore(parseISO(endDate), parseISO(startDate)),
  gradesReleasedAt:
    isEmpty(gradesReleasedAt) ||
    isBefore(parseISO(gradesReleasedAt), parseISO(startDate)),
  maxGrade:
    gradeType === gradeTypes.points.value &&
    (!maxGrade || maxGrade < 1 || maxGrade > 1000),
});

export const hasError = (errors) =>
  Object.values(errors).some((error) => !!error);
